class LWLogo extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }

    connectedCallback() {
        this.render();
    }

    render() {
        this.shadowRoot.innerHTML = /* html */ `
        <style>
            :host {
                /* De container zelf staat vast in de hoek */
                position: absolute;
                bottom: 85px;
                left: 85px;
                width: 40%;
                z-index: 10; /* Altijd bovenop foto's en tekst */
                pointer-events: none; /* Zodat je door het logo heen kunt klikken/scrollen */
            }

            .logo-wrapper {
                width: 100%;
                display: flex;
                align-items: flex-end;
            }

            /* We stylen de ge-slote afbeelding */
            ::slotted(img) {
                width: 100%;
                height: auto;
                display: block;
                filter: drop-shadow(0 2px 10px rgba(0,0,0,0.1));
            }

            @media (max-width: 767px) {
                :host {
                    bottom: 150px;
                    left: 20px;
                    width: 50%; /* Iets groter op mobiel voor leesbaarheid */
                }
            }
        </style>
        <div class="logo-wrapper">
            <slot></slot>
        </div>
        `;
    }
}

customElements.define('lw-logo', LWLogo);